import React from "react";

export default function QuestionReportIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.19526 0.199128C4.32029 0.0716313 4.48985 0 4.66667 0L16 0C17.1046 0 18 0.913171 18 2.03962V11.4823C18 11.8578 17.7015 12.1622 17.3333 12.1622C16.9651 12.1622 16.6667 11.8578 16.6667 11.4823V2.03962C16.6667 1.66414 16.3682 1.35974 16 1.35974H5.33333V4.75911C5.33333 5.13459 5.03487 5.43898 4.66667 5.43898H1.33333V19.8523C1.33333 20.2278 1.63181 20.5321 2 20.5321H12.6486C13.0168 20.5321 13.3153 20.8365 13.3153 21.212C13.3153 21.5875 13.0168 21.8919 12.6486 21.8919H2C0.895433 21.8919 0 20.9788 0 19.8523V4.75911C0 4.57879 0.0702401 4.40587 0.19526 4.27836L4.19526 0.199128ZM2.27614 4.07923H4V2.32123L2.27614 4.07923Z"
        fill="#10D3AB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4465 20.6423C16.4465 21.0637 16.1303 21.4054 15.7403 21.4054C15.3503 21.4054 15.0342 21.0637 15.0342 20.6423C15.0342 20.2208 15.3503 19.8791 15.7403 19.8791C16.1303 19.8791 16.4465 20.2208 16.4465 20.6423ZM14.6869 15.4313C14.8364 15.1232 15.2224 14.8426 15.7403 14.8426C16.4651 14.8426 16.8701 15.352 16.8701 15.7583C16.8701 16.1646 16.4651 16.674 15.7403 16.674C15.4283 16.674 15.1754 16.9474 15.1754 17.2845V18.2766C15.1754 18.6138 15.4283 18.8871 15.7403 18.8871C16.0523 18.8871 16.3052 18.6138 16.3052 18.2766V17.8258C17.2269 17.598 18 16.8249 18 15.7583C18 14.4787 16.8875 13.6216 15.7403 13.6216C14.8684 13.6216 14.0598 14.0944 13.6863 14.8644C13.5414 15.163 13.648 15.5319 13.9243 15.6885C14.2006 15.8451 14.542 15.7299 14.6869 15.4313Z"
        fill="#10D3AB"
      />
      <path
        d="M11.6757 9C11.9444 9 12.1622 9.21781 12.1622 9.48649C12.1622 9.75517 11.9444 9.97297 11.6757 9.97297H3.40543C3.13675 9.97297 2.91895 9.75517 2.91895 9.48649C2.91895 9.21781 3.13675 9 3.40543 9H11.6757Z"
        fill="#10D3AB"
      />
      <path
        d="M14.5945 4.37842C14.8632 4.37842 15.081 4.59623 15.081 4.86491C15.081 5.13358 14.8632 5.35139 14.5945 5.35139L8.27018 5.35139C8.0015 5.35139 7.78369 5.13358 7.78369 4.8649C7.78369 4.59623 8.0015 4.37842 8.27018 4.37842L14.5945 4.37842Z"
        fill="#10D3AB"
      />
      <path
        d="M10.7838 12C11.0525 12 11.2703 12.2178 11.2703 12.4865C11.2703 12.7552 11.0525 12.973 10.7838 12.973H3.48649C3.21781 12.973 3 12.7552 3 12.4865C3 12.2178 3.21781 12 3.48649 12H10.7838Z"
        fill="#10D3AB"
      />
      <path
        d="M8.43241 15C8.70109 15 8.91889 15.2178 8.91889 15.4865C8.91889 15.7552 8.70109 15.973 8.43241 15.973H3.56754C3.29886 15.973 3.08105 15.7552 3.08105 15.4865C3.08105 15.2178 3.29886 15 3.56754 15H8.43241Z"
        fill="#10D3AB"
      />
    </svg>
  );
}
